export default __webpack_public_path__ + "static/media/icon-instagram.32a9619a.png";